import { render, staticRenderFns } from "./DefermentTypeManager.vue?vue&type=template&id=10ca29f9"
import script from "./DefermentTypeManager.vue?vue&type=script&lang=js"
export * from "./DefermentTypeManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports